import React, { ReactElement } from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { KeyValue } from "models/utilTypes/keyValue";
import { ArticleDetailsProps } from "models/propTypes/articlePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { DetailsTableView } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const ArticleDetails: React.FC<ArticleDetailsProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { article } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const onViewAllClick = () => {
    navigate(UrlHelper.formatPath(`/Article/${article.id}/Settings`), {
      state: { background: location },
    });
  };

  const getDetailsList = () => {
    const detailsList: Array<KeyValue<string, string | ReactElement> | typeof ACTION_SEPARATOR> = [
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StandardPrice),
        LocalizationHelperInstance.getFormattedCurrency(article.unitPrice, "SEK")
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Unit),
        article.unitText ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.VatRate),
        article.vat === 0
          ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.VATFree)
          : `${article.vat}%`
      ),
      ACTION_SEPARATOR,
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.EUVatCategory),
        article.euVatProductType ? invoiceService.getEuVatCategoryText(article.euVatProductType) : "-"
      ),
    ];

    return detailsList;
  };

  return (
    <DetailsTableView
      detailsList={getDetailsList()}
      buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllInfo)}
      buttonOnClick={onViewAllClick}
    />
  );
};

export default ArticleDetails;
